import React from "react";
import { ConfigFilterFacet, Filter } from "@usereactify/search";
import { FiltersButton } from "./FiltersButton";

type TypeFilterButtonsProps = {
  filter: ConfigFilterFacet;
};

export const TypeFilterButtons: React.FC<TypeFilterButtonsProps> = (props) => {
  const { filter } = props;

  return (
    <Filter
      filter={filter}
      renderFilterList={({ filterListProps }) => (
        <ul className="no-bullets tag-list tag-list--active-tags">
          {filterListProps.options.map((option) => (
            <FiltersButton
              key={option.key}
              value={filterListProps.value}
              option={option}
              handleChange={filterListProps.handleChange}
            />
          ))}
        </ul>
      )}
    />
  );
};
